import * as Sentry from '@sentry/nextjs'
import { supabase } from './supabase'
import type { AppLocale } from '@/i18n/routing'

/**
 * Mirror the user's locale into auth.users.raw_user_meta_data.locale so
 * Supabase auth-email templates can render per-locale copy via `.Data.locale`.
 *
 * profiles.locale is the source of truth; this is a one-way mirror. Failure
 * is non-fatal — the email template falls back to English when .Data.locale
 * is missing. See C47-446.
 */
export async function syncLocaleToUserMetadata(locale: AppLocale): Promise<void> {
  try {
    const { error } = await supabase.auth.updateUser({ data: { locale } })
    if (error) {
      Sentry.addBreadcrumb({
        category: 'auth',
        message: 'Failed to mirror locale into user_metadata',
        level: 'warning',
        data: { locale, error: error.message },
      })
    }
  } catch (err) {
    Sentry.addBreadcrumb({
      category: 'auth',
      message: 'Locale metadata mirror threw',
      level: 'warning',
      data: { locale, error: err instanceof Error ? err.message : String(err) },
    })
  }
}
